import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
const temas = ['Identidad y construcción personal', 'Autoestima', 'Cambios en la adolescencia', 'Vínculos saludables', 'Consentimiento', 'Violencia en el noviazgo', 'Bullying', 'Ciberbullying', 'Grooming', 'Redes sociales e identidad digital', 'Diversidad', 'Derechos', 'Salud sexual integral', 'Métodos anticonceptivos e ITS', 'Embarazo en la adolescencia', 'Consumo de alcohol', 'Drogas y consumos problemáticos', 'Vapeadores', 'Salud mental', 'Presión de grupo', 'Violencia y seguridad escolar', 'Ciudadanía digital', 'Participación social', 'Proyecto de vida'];
export function IncludesSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-205">
      <div className="max-w-3xl mx-auto" data-id="element-206">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#5B3FA0]" data-id="element-207">
          ¿QUÉ INCLUYE MEGAPACK ESI SECUNDARIA?
        </h2>

        <div className="bg-blue-50 rounded-2xl p-5 border border-blue-100 mb-5" data-id="element-208">
          <h3 className="text-2xl font-bold mb-3 text-[#000000]" data-id="element-209">
            📚 Cuadernillo completo de Educación Sexual Integral
          </h3>

          <div className="flex justify-center mb-4" data-id="element-210">
            <img src="https://cdn.magicpatterns.com/uploads/pRtZ4NNJpC3vWeMef8iJXA/ChatGPT_Image_29_jun_2026,_12_28_03_a.m._-_Editado.png" alt="Megapack ESI Secundaria" className="w-[280px] h-auto object-contain drop-shadow-lg rounded-lg" data-id="element-211" />
          </div>

          <p className="text-lg font-medium mb-3" data-id="element-212">
            Incluye <span className="font-black" data-id="element-213">25 temas fundamentales</span>{' '}
            para trabajar durante todo el año escolar. Entre ellos:
          </p>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1.5 text-base text-gray-800 mb-4" data-id="element-214">
            {temas.map(tema => <li key={tema} className="flex items-start" data-id="element-215">
                <span className="text-blue-500 mr-2 font-bold" data-id="element-216">•</span>
                <span data-id="element-217">{tema}</span>
              </li>)}
          </ul>

          <p className="text-lg font-medium mb-2" data-id="element-218">Cada tema incluye:</p>

          <ul className="space-y-1.5 text-lg text-gray-800 mb-4 pl-4" data-id="element-219">
            <li className="flex items-start" data-id="element-220">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-221">•</span>
              <span data-id="element-222">lectura breve</span>
            </li>
            <li className="flex items-start" data-id="element-223">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-224">•</span>
              <span data-id="element-225">actividad principal</span>
            </li>
            <li className="flex items-start" data-id="element-226">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-227">•</span>
              <span data-id="element-228">análisis de situaciones</span>
            </li>
            <li className="flex items-start" data-id="element-229">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-230">•</span>
              <span data-id="element-231">reflexión crítica</span>
            </li>
            <li className="flex items-start" data-id="element-232">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-233">•</span>
              <span data-id="element-234">producción escrita</span>
            </li>
            <li className="flex items-start" data-id="element-235">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-236">•</span>
              <span data-id="element-237">amplios espacios para responder</span>
            </li>
          </ul>

          <p className="text-lg font-bold text-gray-900 inline-block px-2 mb-2 bg-[#EFF6FF]" data-id="element-238">
            Todo pensado especialmente para estudiantes de Secundaria.
          </p>

          <p className="text-lg text-gray-700" data-id="element-239">
            Cada página fue diseñada para resolver una clase completa.
          </p>
        </div>

        <div className="text-center mt-5" data-id="element-240">
          <CTAButton href="#compra" className="w-full md:w-auto" data-id="element-241">
            🔥 QUIERO MI MEGAPACK ESI SECUNDARIA
          </CTAButton>
        </div>
      </div>
    </section>;
}